import PropTypes from 'prop-types';
import { parseISO } from 'date-fns';
import AppointmentItem from 'components/appointments/appointment-item';
import * as S from './styles';

export default function ListOfDay({ appointments, isCompact }) {
  return (
    <S.ListOfDay>
      {appointments.map((item, index) => (
        <li key={`${item.id}-${item.start || ''}-${String(index)}`}>
          <AppointmentItem
            id={item.id}
            title={item.title}
            type={item.businessEntityType}
            address={item.serviceAddress}
            unitNumber={item.unitNumber}
            totalAmount={item.totalAmount}
            date={parseISO(item.start)}
            endDate={item.end ? parseISO(item.end) : null}
            isAllDay={item.isAllDay}
            isCompact={isCompact}
            employees={item.employees}
            invoice={item.invoiceSent}
            variant="column"
            status={item.status}
          />
        </li>
      ))}
    </S.ListOfDay>
  );
}

ListOfDay.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  appointments: PropTypes.arrayOf(PropTypes.object),
  isCompact: PropTypes.bool,
};

ListOfDay.defaultProps = {
  appointments: [],
  isCompact: false,
};
